const ROLES = [
  {
    id: 4,
    name: 'UsuarioConsulta'
  },
  {
    id: 1,
    name: 'Usuario'
  },
  {
    id: 2,
    name: 'Administrador'
  },
  {
    id: 5,
    name: 'AdminDistribuidor',
    only: ['AdminDistribuidor', 'SuperAdminDistribuidor', 'SuperAdministrador']
  },
  {
    id: 6,
    name: 'SuperAdminDistribuidor',
    only: ['SuperAdminDistribuidor', 'SuperAdministrador']
  },
  {
    id: 3,
    name: 'SuperAdministrador',
    only: ['SuperAdministrador']
  },
]

export {
  ROLES
}
